
import './_common'
import '../blocks/toc/front'
// import './_luminous'
import SearchButton from './components/SearchButton'
const { render } = wp.element

window.addEventListener('load', () => {
  const items = document.querySelectorAll('.mh-show-onload')
  items.forEach(item => {
    item.style.visibility = 'visible'
  })

  // save時に React SVGのプロパティ名のハイフンがなくなる問題を修正
  const buttons = document.querySelectorAll('svg')

  buttons.forEach(item => {
    const replacedHtml = item.outerHTML
      .replaceAll('cliprule', 'clip-rule')
      .replaceAll('fillrule', 'fill-rule')
      .replaceAll('strokelinecap', 'stroke-linecap')
      .replaceAll('strokelinejoin', 'stroke-linejoin')
      .replaceAll('strokewidth', 'stroke-width')
    item.outerHTML = replacedHtml
  })
})

// セレクトボックスの装飾
const selectBox = document.querySelectorAll('.form-select')

selectBox.forEach(item => {
  item.outerHTML = '<div class="form-select-outer">' + item.outerHTML +
  '<span class="material-icons-outlined">keyboard_arrow_down</span></div>'
})

// inputの属性
const disabled = document.querySelectorAll('.disabled')
if (disabled.length > 0) {
  disabled.forEach(item => {
    item.setAttribute('disabled', 'disabled')
  })
}

const readonly = document.querySelectorAll('.readonly')
if (readonly.length > 0) {
  readonly.forEach(item => {
    item.setAttribute('readonly', 'readonly')
  })
}

// リンクボタンの装飾
const linkButton = document.querySelectorAll('.link-button')
linkButton.forEach(item => {
  item.insertAdjacentHTML('beforeend', '<span class="link-button-icon material-icons-outlined">chevron_right</span>')
})

const $searchIcon = document.getElementById('mh-search-button')
if ($searchIcon) {
  render(<SearchButton />, $searchIcon)
}
